import React, { PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import PropTypes from 'prop-types'
import Moment from 'moment'

class DatePickerField extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      startDate: this.props.defaultValue ? Moment(Moment(new Date(this.props.defaultValue)).toISOString()) : Moment()
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (date) {
    this.setState({
      startDate: date
    })
    this.props.onChange({ date: date.toDate().toString() })
  }

  componentDidUpdate (prevProps, prevState) {
    return this.props.defaultValue !== prevProps.defaultValue
      ? this.setState({ startDate: Moment(Moment(new Date(this.props.defaultValue)).toISOString()) })
      : null
  }

  render () {
    return (
      <div className='date-picker'>
        <DatePicker
          className='form__form-group-datepicker'
          selected={this.state.startDate}
          onSelect={this.handleChange}
          minDate={new Date()}
          dateFormat='LL'
        />
      </div>
    )
  }
}

const renderDatePickerField = (props) => (
  <DatePickerField
    {...props.input}
    defaultValue={props.defaultValue}
    controlId={props.controlId}
  />
)

renderDatePickerField.propTypes = {
  input: PropTypes.object.isRequired
}

export default renderDatePickerField



// WEBPACK FOOTER //
// ./src/components/form/DatePicker.js